/* eslint-disable no-use-before-define */

const REQUSET_APP_RATING_KEY = 'REQUSET_APP_RATING_KEY';

const NOW = Date.now();
const DAY = 1000 * 60 * 60 * 24;

const preResponse = JSON.parse(localStorage.getItem(REQUSET_APP_RATING_KEY));

export default class AppRating {
  isShowRequsetAppRating(sDealType, sSatisfyPoint, sDeliveryPoint) {
    const isApp = !TMON.bIsMobileWeb && (TMON.bIsAndroid || TMON.bIsIos);

    const isGreaterScore = this.isGreaterScore(
      5,
      sDealType,
      sSatisfyPoint,
      sDeliveryPoint
    );

    return (
      isApp &&
      isGreaterScore &&
      (preResponse === null ||
        (preResponse.answer === true && NOW - preResponse.date > 30 * DAY) ||
        (preResponse.answer === false && NOW - preResponse.date > 5 * DAY))
    );
  }

  isGreaterScore(num, sDealType, sSatisfyPoint, sDeliveryPoint) {
    return (
      (sDealType === 'DELIVERY' &&
        parseInt(sSatisfyPoint, 10) >= num &&
        parseInt(sDeliveryPoint, 10) >= num) ||
      (sDealType !== 'DELIVERY' && parseInt(sSatisfyPoint, 10) >= num)
    );
  }

  saveResponseToAppRating(answer) {
    localStorage.setItem(
      REQUSET_APP_RATING_KEY,
      JSON.stringify({
        answer,
        date: NOW,
      })
    );
  }

  gotoMarket() {
    if (TMON.bIsAndroid) {
      const win = window.open('market://details?id=com.tmon', '_blank');
      win.focus();
    }
    if (TMON.bIsIos) {
      const win = window.open(
        'itms-apps://itunes.apple.com/app/id463434588',
        '_blank'
      );
      win.focus();
    }
  }
}
